/* <site-features:generated>
 * THE ONE SWITCH — which site mounts which feature.
 *
 * GENERATED from packages/docit-features/manifests/00-sites.md — do not hand-edit; run
 * `pnpm registry:sync`. Add or remove a feature from a site by editing a single line in that
 * document; the guard test (src/generatedRegistry.test.ts) fails the build if you forget to
 * re-run the sync.
 *
 * Every id must exist in a feature manifest — `assertManifestsCohere()` fails the COMPILE on a
 * typo and `assertSitesResolve()` fails the test run, so a bad id cannot reach a deploy.
 *
 * A removal takes effect at the next deploy of that app: its routes stop being registered, its
 * nav entries stop rendering, and its scene chunk stops being reachable. Nothing else in the
 * app needs to change, which is the whole point of the registry.
 */
import type { SiteId } from "./types";

export const siteFeatures: Record<SiteId, string[]> = {
  // desk.docit.pro — the full workspace desk.
  slate: ["market", "people", "share", "subscribe", "work", "git", "mail", "analysis", "briefing"],

  // my.app.co.il — a BUILD PROFILE of slate (slate/src/site.ts), not an app. Its roster is
  // slate's by construction: same bundle, same routes.tsx, different identity only.
  // What it SHOWS is narrower (owner 2026-10-24): marketplace, people and work only — the
  // profile's navSectionOrder in slate/src/siteConfigs.ts; hidden areas redirect to /market.
  // mounts DERIVED from `slate`. To change them, change
  // `slate`'s mounts — or this entry's `mountsAs:` — in
  // manifests/00-sites.md. There is no mounts list here to edit.
  appcoil: [
    "market",
    "people",
    "share",
    "subscribe",
    "work",
    "git",
    "mail",
    "analysis",
    "briefing",
  ],

  // my.app.co.il — app.co.il's own app; marketplace-first.
  coil: ["market", "people", "subscribe", "work", "git", "mail"],

  // kms.docit.pro / kms.app.co.il — the Outline-derived app. It CANNOT mount these React 19
  // package scenes (React 17 + mobx + styled-components), so this list is a statement of
  // intent, not of code: `subscribe` is listed because knowit-main carries its own native
  // subscribe UI against the same server rows and the same producer. See the README's
  // "knowit-main" section for the full assessment. `git` likewise: native scenes in
  // knowit-main against the same `git.connections.*` endpoints (2026-09-24).
  knowit: ["subscribe", "work", "git"],

  // www.app.co.il — the public, unauthenticated marketing face. It mounts no authenticated
  // feature; its market pages are public SEO surfaces served by cortado's own code.
  cortado: [],
};
/* </site-features:generated> */
